import type { AlternativeSearchState, AlternativeSearchView } from './types';

export default class NotFoundState implements AlternativeSearchState {
  readonly criteria = null;

  readonly view: AlternativeSearchView = { kind: 'notFound' };
}
